import styled from "styled-components";

export default styled.div`
  h1 {
    font-size: 1.7rem !important;
  }
  padding: 20px;
  .visa-description {
    font-size: 0.75rem;
    color: #767676;
  }
  small a {
    span {
      vertical-align: middle;
    }
  }
`;
